
<div class="container">
    <h1 class="plan-title">Subscription Details</h1>
    <div class="plan-container">
        <div class="card" *ngIf="planType=='Basic'">
            <div>
            <h2>Free</h2>
            <p>For Business That Need Outstanding Designs To Stand Out</p>
            </div>
            <div>
                <span class="price">₹ 0 </span>/ Month
            </div>
            <button class="choose-button"> Upgrade </button>
            <div>
                <div class="divider">
                    <span>Features</span>
                </div>
                
                <ul class="features">
                    <li><i class="bi bi-check-circle-fill text-dark me-2"></i> Access to core features</li>
                    <li><i class="bi bi-check-circle-fill text-dark me-2"></i> Up to 5 projects</li>
                    <li><i class="bi bi-check-circle-fill text-dark me-2"></i> Community support</li>
                    <li><i class="bi bi-check-circle-fill text-dark me-2"></i> Email support</li>
                </ul>           
            </div>
        </div>
        <div class="card" *ngIf="planType === 'Basic' || planType === 'Plus'">
            <div>
            <h2>Plus </h2>
            <p>For Business That Need Outstanding Designs To Stand Out</p>
            </div>
            <div>
                <span class="price">₹ 199 </span>/ Month
            </div>
            <button class="choose-button"> Upgrade </button>
            <div>
                <div class="divider">
                    <span>Features</span>
                </div>
                
                <ul class="features">
                    <li><i class="bi bi-check-circle-fill text-dark me-2"></i> Access to core features</li>
                    <li><i class="bi bi-check-circle-fill text-dark me-2"></i> Up to 5 projects</li>
                    <li><i class="bi bi-check-circle-fill text-dark me-2"></i> Community support</li>
                    <li><i class="bi bi-check-circle-fill text-dark me-2"></i> Email support</li>
                </ul>           
            </div>
        </div>

        <div class="card">
            <div>
            <h2>Pro </h2>
            <p>For Business That Need Outstanding Designs To Stand Out</p>
            </div>
            <div>
                <span class="price">₹ 299 </span>/ Month
            </div>
            <button class="choose-button"> Upgrade</button>
            <div>
                <div class="divider">
                    <span>Features</span>
                </div>
                
                <ul class="features">
                    <li><i class="bi bi-check-circle-fill text-dark me-2"></i> All Basic Plan features</li>
                    <li><i class="bi bi-check-circle-fill text-dark me-2"></i> Unlimited projects</li>
                    <li><i class="bi bi-check-circle-fill text-dark me-2"></i> Priority customer support</li>
                    <li><i class="bi bi-check-circle-fill text-dark me-2"></i> Advanced analytics</li>
                </ul>           
            </div>
        </div>
    </div>
</div>